import { render, staticRenderFns } from "./add-customer.vue?vue&type=template&id=3d2a2b67&scoped=true"
import script from "./add-customer.vue?vue&type=script&lang=js"
export * from "./add-customer.vue?vue&type=script&lang=js"
import style0 from "./add-customer.vue?vue&type=style&index=0&id=3d2a2b67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a2b67",
  null
  
)

export default component.exports